import { stringValue } from 'vega-util';
import { TUPLE, isTimerSelection, unitName } from '.';
import { SELECTION_ID } from '../../selection';
import { vals } from '../../util';
import { BRUSH } from './interval';
import { TUPLE_FIELDS } from './project';
import { TIME } from '../../channel';
export var CURR = '_curr';
export var ANIM_VALUE = 'anim_value';
export var ANIM_CLOCK = 'anim_clock';
export var EASED_ANIM_CLOCK = 'eased_anim_clock';
export var MIN_EXTENT = 'min_extent';
export var MAX_RANGE_EXTENT = 'max_range_extent';
export var LAST_TICK = 'last_tick_at';
export var IS_PLAYING = 'is_playing';
export var THROTTLE = 1 / 60 * 1000; // 60 FPS
var animationSignals = function animationSignals(selectionName, scaleName) {
  return [
  // timer signals
  {
    name: EASED_ANIM_CLOCK,
    // update: 'easeLinear(anim_clock / max_range_extent) * max_range_extent'
    update: ANIM_CLOCK // TODO: replace with above once easing functions are implemented in vega-functions
  },
  // scale signals
  // TODO(jzong): uncomment commented signals below when implementing interpolation
  {
    name: "".concat(selectionName, "_domain"),
    init: "domain('".concat(scaleName, "')")
  }, {
    name: MIN_EXTENT,
    init: "extent(".concat(selectionName, "_domain)[0]")
  },
  // {name: 'max_extent', init: `extent(${selectionName}_domain)[1]`},
  {
    name: MAX_RANGE_EXTENT,
    init: "extent(range('".concat(scaleName, "'))[1]")
  },
  // {name: 't_index', update: `indexof(${selectionName}_domain, anim_value)`},
  {
    name: ANIM_VALUE,
    update: "invert('".concat(scaleName, "', ").concat(EASED_ANIM_CLOCK, ")")
  }];
};
var point = {
  defined: function defined(selCmpt) {
    return selCmpt.type === 'point';
  },
  topLevelSignals: function topLevelSignals(model, selCmpt, signals) {
    if (isTimerSelection(selCmpt)) {
      signals = signals.concat([{
        name: ANIM_CLOCK,
        init: '0',
        on: [{
          events: {
            type: 'timer',
            throttle: THROTTLE
          },
          update: "".concat(IS_PLAYING, " ? (").concat(ANIM_CLOCK, " + (now() - ").concat(LAST_TICK, ") > ").concat(MAX_RANGE_EXTENT, " ? 0 : ").concat(ANIM_CLOCK, " + (now() - ").concat(LAST_TICK, ")) : ").concat(ANIM_CLOCK)
        }]
      }, {
        name: LAST_TICK,
        init: 'now()',
        on: [{
          events: [{
            signal: ANIM_CLOCK
          }, {
            signal: IS_PLAYING
          }],
          update: 'now()'
        }]
      }, {
        name: IS_PLAYING,
        init: 'true'
      }]);
    }
    return signals;
  },
  signals: function signals(model, selCmpt, _signals) {
    var _model$component$sele;
    var name = selCmpt.name;
    var fieldsSg = name + TUPLE_FIELDS;
    var project = selCmpt.project;
    var datum = '(item().isVoronoi ? datum.datum : datum)';
    // Only add a discrete selection to the store if a datum is present _and_
    // the interaction isn't occurring on a group mark. This guards against
    // polluting interactive state with invalid values in faceted displays
    // as the group marks are also data-driven. We force the update to account
    // for constant null states but varying toggles (e.g., shift-click in
    // whitespace followed by a click in whitespace; the store should only
    // be cleared on the second click).
    var brushes = vals((_model$component$sele = model.component.selection) !== null && _model$component$sele !== void 0 ? _model$component$sele : {}).reduce(function (acc, cmpt) {
      return cmpt.type === 'interval' ? acc.concat(cmpt.name + BRUSH) : acc;
    }, []).map(function (b) {
      return "indexof(item().mark.name, '".concat(b, "') < 0");
    }).join(' && ');
    var test = "datum && item().mark.marktype !== 'group' && indexof(item().mark.role, 'legend') < 0".concat(brushes ? " && ".concat(brushes) : '');
    var update = "unit: ".concat(unitName(model), ", ");
    if (selCmpt.project.hasSelectionId) {
      update += "".concat(SELECTION_ID, ": ").concat(datum, "[").concat(stringValue(SELECTION_ID), "]");
    } else if (isTimerSelection(selCmpt)) {
      update += "fields: ".concat(fieldsSg, ", values: [").concat(ANIM_VALUE, " ? ").concat(ANIM_VALUE, " : ").concat(MIN_EXTENT, "]");
    } else {
      var values = project.items.map(function (p) {
        var fieldDef = model.fieldDef(p.channel);
        // Binned fields should capture extents, for a range test against the raw field.
        return fieldDef !== null && fieldDef !== void 0 && fieldDef.bin ? "[".concat(datum, "[").concat(stringValue(model.vgField(p.channel, {})), "], ") + "".concat(datum, "[").concat(stringValue(model.vgField(p.channel, {
          binSuffix: 'end'
        })), "]]") : "".concat(datum, "[").concat(stringValue(p.field), "]");
      }).join(', ');
      update += "fields: ".concat(fieldsSg, ", values: [").concat(values, "]");
    }
    if (isTimerSelection(selCmpt)) {
      // timer event: selection is for animation
      return _signals.concat(animationSignals(selCmpt.name, model.scaleName(TIME)), [{
        name: name + TUPLE,
        on: [{
          events: [{
            signal: EASED_ANIM_CLOCK
          }, {
            signal: ANIM_VALUE
          }],
          update: "{".concat(update, "}"),
          force: true
        }]
      }]);
    } else {
      var events = selCmpt.events;
      return _signals.concat([{
        name: name + TUPLE,
        on: events ? [{
          events: events,
          update: "".concat(test, " ? {").concat(update, "} : null"),
          force: true
        }] : []
      }]);
    }
  }
};
export default point;